<template>
    <div class="popup" :class="[className]">

        <div class="popup__wrapper" :style="{width: width, height: height}">

            <button class="popup-close" @click="toggleModal" v-if="closeable">
                <img src="../../assets/images/close-big.svg" alt="Close" width="10px" height="10px">
            </button>

            <div class="popup-content">
                <slot></slot>
            </div>

        </div>

    </div>
</template>

<script>

export default {
    props: {
        width:{
            type: String,
            default: '400px'
        },
        height:{
            type: String,
            default: 'auto'
        },
        className: {
            type: String,
        }, 
        closeable: {
            type: Boolean,
        },
    },
    data() {
        return {
        };
    },
    methods: {
        toggleModal () {
            this.$emit('closePopup');
        }
    }
};

</script>

<style lang="scss">
    @import '../../style/common/Popup.scss';
</style>
